import './Tolerance.css';

import { FormControlLabel, Radio, RadioGroup } from '@mui/material';
import { generateClassName } from '../../../b2b-common/helpers';
import React, { useEffect, useState } from 'react';
import EditText from '../../../b2b-common/EditText';
import FieldComponent from '../../../b2b-common/FieldComponent';
import useB2BTranslation from '../../../b2b-common/hooks/useB2BTranslation';

const ToleranceOptions = ({ objective, setObjective, edit = false }) => {
    const { t } = useB2BTranslation('b2b-plans');
    // console.log('ToleranceOptions objective:', objective);
    const options = [
        { value: 'ABSOLUTE_VALUE', label: t('Absolute value') },
        { value: 'PERCENTAGE', label: t('Percentage') }
    ];

    const [selectedValue, setSelectedValue] = useState(objective.penaltiesExpressedAs || 'ABSOLUTE_VALUE');

    const handleToleranceChange = (event) => {
        const value = event.target.value;
        setSelectedValue(value);
        setObjective(prevState => ({ ...prevState, penaltiesExpressedAs: value }));
    }

    return (
        <RadioGroup
            className='tolerance-options'
            value={selectedValue}
            onChange={handleToleranceChange}
        >
            {options.map((option, index) => (
                <FormControlLabel key={index} value={option.value} control={<Radio />} label={option.label}
                    className='tolerance-option-label'
                />
            ))}
        </RadioGroup>
    );
};

const Tolerance = ({ objective, setObjective, edit = false, className = null }) => {
    const [toleranceSuffix, setToleranceSuffix] = useState('');
    const { t } = useB2BTranslation('b2b-plans');

    useEffect(() => {
        if (objective) {
            if (objective.penaltiesExpressedAs === 'ABSOLUTE_VALUE')
                setToleranceSuffix('');
            else if (objective.penaltiesExpressedAs === 'PERCENTAGE')
                setToleranceSuffix('%');
        }
    }, [objective]);

    return (
        <div className={generateClassName('tolerance', '-container', className)}>
            <EditText 
                object={objective} 
                objectField={'penalties'} 
                setObjectField={setObjective} 
                label={t('Tolerance')} 
                className={'tolerance-value'} 
                suffix={toleranceSuffix} 
            />
            <FieldComponent
                label={t('Tolerance expressed as:')}
                labelAlign='left'
                component={<ToleranceOptions objective={objective} setObjective={setObjective} edit={edit} />}
                className={'tolerance-options'}
            />
        </div>
    );
};

export default Tolerance;